import { render, staticRenderFns } from "./UITable.vue?vue&type=template&id=b2e55db8&scoped=true&"
import script from "./UITable.vue?vue&type=script&lang=ts&"
export * from "./UITable.vue?vue&type=script&lang=ts&"
import style0 from "./UITable.vue?vue&type=style&index=0&id=b2e55db8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e55db8",
  null
  
)

export default component.exports